var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_8996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89286 5.41762L8.89286 3.5C8.89286 2.39543 7.99743 1.5 6.89286 1.5H3.125C2.02043 1.5 1.125 2.39543 1.125 3.5L1.125 12.5C1.125 13.6046 2.02043 14.5 3.125 14.5H6.89286C7.99743 14.5 8.89286 13.6046 8.89286 12.5V10.6685M4.17256 8.06521H14.875M14.875 8.06521L12.1528 3.84769M14.875 8.06521L12.1528 12.262",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_8996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoutIcon);
export default __webpack_public_path__ + "static/media/profile-logout-icon.e80ca895102c078a2de854be54dcb0b2.svg";
export { ForwardRef as ReactComponent };